var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "activeApply active edit" },
    [
      _c(
        "van-cell-group",
        {},
        [
          _c(
            "van-cell",
            { attrs: { title: "活动名称" } },
            [
              _c("van-field", {
                staticClass: "item2",
                attrs: { placeholder: "请输入活动名称" },
                on: {
                  input: function($event) {
                    return _vm.limitLength(100, "campaign", "Name")
                  }
                },
                model: {
                  value: _vm.campaign.Name,
                  callback: function($$v) {
                    _vm.$set(_vm.campaign, "Name", $$v)
                  },
                  expression: "campaign.Name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("van-cell", { attrs: { title: "活动日期" } }, [
            _c(
              "div",
              { staticClass: "flex" },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex item1",
                    on: {
                      click: function($event) {
                        _vm.showDateTime1 = !_vm.showDateTime1
                      }
                    }
                  },
                  [
                    _vm.campaign.U_RangeTime
                      ? _c("p", { staticClass: "item1 date-time black" }, [
                          _vm._v(_vm._s(_vm.firstDate))
                        ])
                      : _c("p", { staticClass: "item1 date-time" }, [
                          _vm._v(_vm._s(_vm.firstDate || "请选择"))
                        ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "triangle_border_down",
                      attrs: { slot: "right-icon" },
                      slot: "right-icon"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "van-popup",
                  {
                    attrs: { position: "bottom" },
                    model: {
                      value: _vm.showDateTime1,
                      callback: function($$v) {
                        _vm.showDateTime1 = $$v
                      },
                      expression: "showDateTime1"
                    }
                  },
                  [
                    _c("van-datetime-picker", {
                      attrs: { type: "date", "min-date": new Date() },
                      on: {
                        confirm: _vm.getFirstDate,
                        cancel: function($event) {
                          _vm.showDateTime1 = !_vm.showDateTime1
                        }
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "flex item1",
                    on: {
                      click: function($event) {
                        _vm.showDateTime2 = !_vm.showDateTime2
                      }
                    }
                  },
                  [
                    _vm.campaign.U_RangeTime
                      ? _c("p", { staticClass: "item1 date-time black" }, [
                          _vm._v(_vm._s(_vm.endDate))
                        ])
                      : _c("p", { staticClass: "item1 date-time" }, [
                          _vm._v(_vm._s(_vm.endDate || "请选择"))
                        ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "triangle_border_down",
                      attrs: { slot: "right-icon" },
                      slot: "right-icon"
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "van-popup",
                  {
                    attrs: { position: "bottom" },
                    model: {
                      value: _vm.showDateTime2,
                      callback: function($$v) {
                        _vm.showDateTime2 = $$v
                      },
                      expression: "showDateTime2"
                    }
                  },
                  [
                    _c("van-datetime-picker", {
                      attrs: { type: "date", "min-date": new Date() },
                      on: {
                        confirm: _vm.getLastDate,
                        cancel: function($event) {
                          _vm.showDateTime2 = !_vm.showDateTime2
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c(
            "van-cell",
            { attrs: { title: "活动地点" } },
            [
              _c("van-field", {
                staticClass: "item2",
                attrs: { placeholder: "请输入活动地点" },
                on: {
                  input: function($event) {
                    return _vm.limitLength(254, "campaign", "U_CampPlace")
                  }
                },
                model: {
                  value: _vm.campaign.U_CampPlace,
                  callback: function($$v) {
                    _vm.$set(_vm.campaign, "U_CampPlace", $$v)
                  },
                  expression: "campaign.U_CampPlace"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "van-cell",
            { attrs: { title: "邀请人数" } },
            [
              _c("van-field", {
                staticClass: "item2",
                attrs: { type: "number", placeholder: "请输入邀请人数" },
                on: {
                  input: function($event) {
                    return _vm.limitLength(64, "campaign", "U_InvitedCnt")
                  }
                },
                model: {
                  value: _vm.campaign.U_InvitedCnt,
                  callback: function($$v) {
                    _vm.$set(_vm.campaign, "U_InvitedCnt", $$v)
                  },
                  expression: "campaign.U_InvitedCnt"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "van-cell",
            { attrs: { title: "集客目标" } },
            [
              _c("van-field", {
                staticClass: "item2",
                attrs: { type: "number", placeholder: "请输入集客目标" },
                on: {
                  input: function($event) {
                    return _vm.limitLength(100, "campaign", "U_FansTarget")
                  }
                },
                model: {
                  value: _vm.campaign.U_FansTarget,
                  callback: function($$v) {
                    _vm.$set(_vm.campaign, "U_FansTarget", $$v)
                  },
                  expression: "campaign.U_FansTarget"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "van-cell",
            { attrs: { title: "销售目标" } },
            [
              _c("van-field", {
                staticClass: "item2",
                attrs: { type: "number", placeholder: "请输入销售目标" },
                on: {
                  input: function($event) {
                    return _vm.limitLength(100, "campaign", "U_SaleTarget")
                  }
                },
                model: {
                  value: _vm.campaign.U_SaleTarget,
                  callback: function($$v) {
                    _vm.$set(_vm.campaign, "U_SaleTarget", $$v)
                  },
                  expression: "campaign.U_SaleTarget"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "van-cell",
            { attrs: { title: "讲师姓名" } },
            [
              _c("van-field", {
                staticClass: "item2",
                attrs: { placeholder: "请输入讲师姓名" },
                on: {
                  input: function($event) {
                    return _vm.limitLength(100, "campaign", "U_TeacherName")
                  }
                },
                model: {
                  value: _vm.campaign.U_TeacherName,
                  callback: function($$v) {
                    _vm.$set(_vm.campaign, "U_TeacherName", $$v)
                  },
                  expression: "campaign.U_TeacherName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "van-cell",
            { attrs: { title: "合作伙伴" } },
            [
              _c("van-field", {
                staticClass: "item2",
                attrs: { placeholder: "请输入合作伙伴" },
                on: {
                  input: function($event) {
                    return _vm.limitLength(100, "campaign", "U_Partner")
                  }
                },
                model: {
                  value: _vm.campaign.U_Partner,
                  callback: function($$v) {
                    _vm.$set(_vm.campaign, "U_Partner", $$v)
                  },
                  expression: "campaign.U_Partner"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "van-cell",
            {
              attrs: { title: "活动类型" },
              on: {
                click: function($event) {
                  _vm.showTypes = !_vm.showTypes
                }
              }
            },
            [
              _c("div", { staticClass: "flex item1" }, [
                _vm.typeName
                  ? _c("p", { staticClass: "item1 date-time black" }, [
                      _vm._v(_vm._s(_vm.typeName))
                    ])
                  : _c("p", { staticClass: "item1 date-time" }, [
                      _vm._v("请选择")
                    ]),
                _vm._v(" "),
                _c("div", {
                  staticClass: "triangle_border_down",
                  attrs: { slot: "right-icon" },
                  slot: "right-icon"
                })
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group" },
        [
          _c("van-cell", { attrs: { title: "活动主题" } }),
          _vm._v(" "),
          _c("quillEditImg", {
            attrs: { quillId: "U_Theme", content: _vm.campaign.U_Theme },
            on: {
              change: function($event) {
                return _vm.onEditorChange($event, "U_Theme")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group" },
        [
          _c("van-cell", { attrs: { title: "活动目的" } }),
          _vm._v(" "),
          _c("quillEditImg", {
            attrs: { quillId: "U_Purpose", content: _vm.campaign.U_Purpose },
            on: {
              change: function($event) {
                return _vm.onEditorChange($event, "U_Purpose")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group" },
        [
          _c("van-cell", { attrs: { title: "讲师介绍" } }),
          _vm._v(" "),
          _c("quillEditImg", {
            attrs: {
              quillId: "U_Instructor",
              content: _vm.campaign.U_Instructor
            },
            on: {
              change: function($event) {
                return _vm.onEditorChange($event, "U_Instructor")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group" },
        [
          _c("van-cell", { attrs: { title: "场地介绍" } }),
          _vm._v(" "),
          _c("quillEditImg", {
            attrs: { quillId: "U_Venue", content: _vm.campaign.U_Venue },
            on: {
              change: function($event) {
                return _vm.onEditorChange($event, "U_Venue")
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group group-table" },
        [
          _c("van-cell", { attrs: { title: "活动流程" } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table van-hairline--surround" },
            [
              _c("div", { staticClass: "table-title flex" }, [
                _c("p", { staticClass: "item1" }, [_vm._v("序号")]),
                _vm._v(" "),
                _c("p", { staticClass: "item2" }, [_vm._v("日期")]),
                _vm._v(" "),
                _c("p", { staticClass: "item2" }, [_vm._v("时间")]),
                _vm._v(" "),
                _c("p", { staticClass: "item3" }, [_vm._v("内容")])
              ]),
              _vm._v(" "),
              _vm._l(_vm.processList, function(item, index) {
                return [
                  _c(
                    "ul",
                    {
                      staticClass: "table-content flex van-hairline--top",
                      on: {
                        click: function($event) {
                          return _vm.liuchengEdit(item, index)
                        }
                      }
                    },
                    [
                      _c("li", { staticClass: "item1 van-hairline--right" }, [
                        _vm._v(_vm._s(item.U_Sort))
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "item2 van-hairline--right" }, [
                        _vm._v(_vm._s(_vm._f("getActiveDate")(item.U_Flow)))
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "item2 van-hairline--right" }, [
                        _vm._v(_vm._s(_vm._f("getActiveTime")(item.U_Flow)))
                      ]),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "item3 flex" },
                        [
                          _c(
                            "p",
                            { staticClass: "item1 van-hairline--right" },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    "line-height": "20px",
                                    display: "inline-block"
                                  }
                                },
                                [_vm._v(_vm._s(item.U_Details))]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("van-icon", {
                            staticClass: "close",
                            attrs: { name: "cross" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.processList.splice(index, 1)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-content add-table van-hairline--top",
                  on: {
                    click: function($event) {
                      return _vm.liuchengEdit()
                    }
                  }
                },
                [_vm._v("\n              +添加一栏\n          ")]
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group group-table" },
        [
          _c(
            "van-cell",
            [
              _c("template", { slot: "title" }, [
                _c("span", { staticClass: "custom-text" }, [_vm._v("活动预算")])
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table van-hairline--surround" },
            [
              _c("div", { staticClass: "table-title flex" }, [
                _c("p", { staticClass: "item1" }, [_vm._v("序号")]),
                _vm._v(" "),
                _c("p", { staticClass: "item2" }, [_vm._v("名称")]),
                _vm._v(" "),
                _c("p", { staticClass: "item1" }, [_vm._v("数量")]),
                _vm._v(" "),
                _c("p", { staticClass: "item3" }, [_vm._v("未税费用")]),
                _vm._v(" "),
                _c("p", { staticClass: "item3" }, [_vm._v("含税费用")])
              ]),
              _vm._v(" "),
              _vm._l(_vm.budgetList, function(item, index) {
                return [
                  _c(
                    "ul",
                    {
                      staticClass: "table-content flex van-hairline--top",
                      on: {
                        click: function($event) {
                          return _vm.yusuanEdit(item, index)
                        }
                      }
                    },
                    [
                      _c("li", { staticClass: "item1 van-hairline--right" }, [
                        _vm._v(_vm._s(index + 1))
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "item2 van-hairline--right" }, [
                        _vm._v(_vm._s(item.Name))
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "item1 van-hairline--right" }, [
                        _vm._v(_vm._s(item.U_Qty))
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "item3 van-hairline--right" }, [
                        _vm._v(_vm._s(item.U_Amount))
                      ]),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "item3 flex" },
                        [
                          _c(
                            "p",
                            { staticClass: "item1 van-hairline--right" },
                            [_vm._v(_vm._s(item.U_AmountAftTax))]
                          ),
                          _vm._v(" "),
                          _c("van-icon", {
                            staticClass: "close",
                            attrs: { name: "cross" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.budgetList.splice(index, 1)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-content add-table van-hairline--top",
                  on: {
                    click: function($event) {
                      return _vm.yusuanEdit()
                    }
                  }
                },
                [_vm._v("\n          +添加一栏\n        ")]
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group group-table" },
        [
          _c(
            "van-cell",
            [
              _c("template", { slot: "title" }, [
                _c("span", { staticClass: "custom-text" }, [_vm._v("物料申请")])
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "table van-hairline--surround" },
            [
              _c("div", { staticClass: "table-title flex" }, [
                _c("p", { staticClass: "item1" }, [_vm._v("序号")]),
                _vm._v(" "),
                _c("p", { staticClass: "item3" }, [_vm._v("产品一级分类")]),
                _vm._v(" "),
                _c("p", { staticClass: "item2" }, [_vm._v("产品名称")]),
                _vm._v(" "),
                _c("p", { staticClass: "item1" }, [_vm._v("数量")]),
                _vm._v(" "),
                _c("p", { staticClass: "item3" }, [_vm._v("归还日期")])
              ]),
              _vm._v(" "),
              _vm._l(_vm.materialList, function(item, index) {
                return [
                  _c(
                    "ul",
                    {
                      staticClass: "table-content flex van-hairline--top",
                      on: {
                        click: function($event) {
                          return _vm.wuliaoEdit(item, index)
                        }
                      }
                    },
                    [
                      _c("li", { staticClass: "item1 van-hairline--right" }, [
                        _vm._v(_vm._s(index + 1))
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "item3 van-hairline--right" }, [
                        _vm._v(_vm._s(item.U_MaterialClass))
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "item2 van-hairline--right" }, [
                        _vm._v(_vm._s(item.Name))
                      ]),
                      _vm._v(" "),
                      _c("li", { staticClass: "item1 van-hairline--right" }, [
                        _vm._v(_vm._s(item.U_Qty))
                      ]),
                      _vm._v(" "),
                      _c(
                        "li",
                        { staticClass: "item3 flex" },
                        [
                          _c(
                            "p",
                            { staticClass: "item1 van-hairline--right" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm._f("getDate")(item.U_ReturnDate)) +
                                  "\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("van-icon", {
                            staticClass: "close",
                            attrs: { name: "cross" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.materialList.splice(index, 1)
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "table-content add-table van-hairline--top",
                  on: {
                    click: function($event) {
                      return _vm.wuliaoEdit()
                    }
                  }
                },
                [_vm._v("\n        +添加一栏\n      ")]
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group" },
        [
          _c("van-cell", { attrs: { title: "图片" } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "clear" },
            [
              _vm._l(_vm.imgList, function(item, index) {
                return [
                  _c(
                    "p",
                    { staticClass: "upload-img fl" },
                    [
                      _c("img", {
                        attrs: {
                          src: _vm.$config.serverURL + "/upload/" + item.U_url,
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c("van-icon", {
                        staticClass: "del-icon",
                        attrs: {
                          name: "clear",
                          color: "#e83c39",
                          size: "20px"
                        },
                        on: {
                          click: function($event) {
                            return _vm.delImg(index)
                          }
                        }
                      })
                    ],
                    1
                  )
                ]
              }),
              _vm._v(" "),
              _c(
                "van-uploader",
                {
                  staticClass: "upload fl",
                  attrs: { "after-read": _vm.afterRead, multiple: "" }
                },
                [
                  _c("van-icon", { attrs: { name: "plus" } }),
                  _vm._v(" "),
                  _c("p", [_vm._v("上传图片")])
                ],
                1
              )
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "group" },
        [
          _c(
            "van-cell",
            [
              _c("template", { slot: "title" }, [
                _c("span", { staticClass: "custom-text" }, [_vm._v("备注")])
              ])
            ],
            2
          ),
          _vm._v(" "),
          _c("van-field", {
            staticClass: "textarea",
            attrs: {
              type: "textarea",
              placeholder: "请输入备注内容描述",
              rows: "3",
              autosize: ""
            },
            on: {
              input: function($event) {
                return _vm.limitLength(254, "campaign", "U_Remark")
              }
            },
            model: {
              value: _vm.campaign.U_Remark,
              callback: function($$v) {
                _vm.$set(_vm.campaign, "U_Remark", $$v)
              },
              expression: "campaign.U_Remark"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "bottom-btn flex" }, [
        _c(
          "div",
          {
            staticClass: "item1 btn save",
            on: {
              click: function($event) {
                return _vm.sub(_vm.campStatus.D)
              }
            }
          },
          [_vm._v("保存")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "item1 btn sub",
            on: {
              click: function($event) {
                return _vm.sub(_vm.campStatus.W)
              }
            }
          },
          [_vm._v("提交")]
        )
      ]),
      _vm._v(" "),
      _c("typePop", {
        attrs: { typeId: _vm.campaign.U_CampType },
        on: { typeChange: _vm.typeChange },
        model: {
          value: _vm.showTypes,
          callback: function($$v) {
            _vm.showTypes = $$v
          },
          expression: "showTypes"
        }
      }),
      _vm._v(" "),
      _c("liuchengPop", {
        attrs: {
          maxDate: _vm.endDate,
          minDate: _vm.firstDate,
          obj: _vm.liuchengValue
        },
        on: { newLiucheng: _vm.newLiucheng },
        model: {
          value: _vm.showliucheng,
          callback: function($$v) {
            _vm.showliucheng = $$v
          },
          expression: "showliucheng"
        }
      }),
      _vm._v(" "),
      _c("yusuanPop", {
        attrs: { info: _vm.yusuanValue },
        on: { newYusuan: _vm.newYusuan },
        model: {
          value: _vm.showYusuan,
          callback: function($$v) {
            _vm.showYusuan = $$v
          },
          expression: "showYusuan"
        }
      }),
      _vm._v(" "),
      _c("wuliaoPop", {
        attrs: { info: _vm.wuliaoValue },
        on: { newWuliao: _vm.newWuliao },
        model: {
          value: _vm.showWuliao,
          callback: function($$v) {
            _vm.showWuliao = $$v
          },
          expression: "showWuliao"
        }
      }),
      _vm._v(" "),
      _c("backTo", { attrs: { url: "/active/list" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d3afbe96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3afbe96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/active/apply.vue
// module id = null
// module chunks = 